import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {formatErrors, userAllergies, userDiseases} from "../../../constants";
import {clientUpdateAction} from "../../../actions/clientAction";
import {toast} from "react-toastify";
import {i_close} from "../../../icons";
import {InputDropdown} from "../../../utils/inputDropdown/InputDropdown";
import {InputUserForm} from "../../../utils/input/InputUserForm";

export function ClientDiseases({client, handleChange, healthTab = false}) {
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState({});
  const [diseaseOptions, setDiseaseOptions] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    setForm({
      diseases: client.diseases ? client.diseases.split(',') : [],
      allergies: client.allergies ? client.allergies.split(',') : [],
      diseases_kidneys: client.diseases_kidneys || '',
      diseases_gynecology: client.diseases_gynecology || '',
      diseases_thyroid: client.diseases_thyroid || '',
      diseases_cardio: client.diseases_cardio || '',
      diseases_other: client.diseases_other || ''
    });
  }, [client.diseases, client.allergies, client.diseases_kidneys, client.diseases_gynecology, client.diseases_thyroid, client.diseases_cardio, client.diseases_other]);

  const handleCancel = () => {
    if (edit === 'loading') {
      return;
    }
    setForm({
      diseases: client.diseases ? client.diseases.split(',') : [],
      allergies: client.allergies ? client.allergies.split(',') : [],
      diseases_kidneys: client.diseases_kidneys || '',
      diseases_gynecology: client.diseases_gynecology || '',
      diseases_thyroid: client.diseases_thyroid || '',
      diseases_cardio: client.diseases_cardio || '',
      diseases_other: client.diseases_other || ''
    });
    setEdit(false);
  };

  const handleSave = () => {
    if (edit === 'loading') {
      return;
    }
    setEdit('loading');
    const values = {...form};
    values['diseases'] = values['diseases'].join(',');
    values['allergies'] = values['allergies'].join(',');
    dispatch(clientUpdateAction(client.id, values)).then(() => {
      setEdit(false);
      handleChange(values);
    }).catch(err => {
      setEdit(true);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value}
    });
  };

  const handleAllergySelected = (item) => {
    setForm((form) => {
      return {...form, allergies: [item].concat(form.allergies)}
    });
  };

  const handleAllergyDeleted = (index) => {
    setForm((form) => {
      const new_allergies = form.allergies.slice();
      new_allergies.splice(index, 1);
      return {...form, allergies: new_allergies};
    });
  };

  const handleDiseaseDeleted = (index) => {
    setForm((form) => {
      const new_diseases = form.diseases.slice();
      new_diseases.splice(index, 1);
      return {...form, diseases: new_diseases};
    });
  };

  const handleDiseaseSelected = (e) => {
    setForm((form) => {
      return {...form, diseases: [e.target.value].concat(form.diseases)}
    });
  };

  useEffect(() => {
    if (form.diseases) {
      setDiseaseOptions(userDiseases.filter(i => form.diseases.indexOf(i) < 0));
    }
  }, [form.diseases]);

  if (healthTab) {
    return <div className={"tabs__wrapper" + (edit ? " tabs__wrapper--edit" : "")}>
      {!edit && <span className="tabs__edit edit pointer" onClick={() => setEdit(true)}>Ред.</span>}
      <div className="tabs__inner">
        <div className="tabs__heading">Заболевания</div>
        <ul className="tabs__value">
          {edit && form && <select className="tabs__input select" value={''} disabled={edit === 'loading'} onChange={handleDiseaseSelected}>
            <option value="">Выберите</option>
            {diseaseOptions.map((i, k) => <option key={k} value={i}>{i}</option>)}
          </select>}
          {
            form.diseases && form.diseases.length > 0 && form.diseases.map((i, k) => <li key={k} className="tabs__elem">{i}{edit === true && <span className="tabs__elem--close" onClick={() => handleDiseaseDeleted(k)}>{i_close()}</span>}</li>)
          }
          {
            form.diseases && form.diseases.length === 0 && <li className="tabs__elem">Нет болезней</li>
          }
        </ul>
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Почки (диагноз, поставленный врачом)</div>
        {!edit && client.diseases_kidneys && <div className="tabs__value">{client.diseases_kidneys}</div>}
        {!edit && !client.diseases_kidneys && <div className="tabs__value">&mdash;</div>}
        {edit && <div className="tabs__value">
          <InputUserForm type="text" value={form.diseases_kidneys} name="diseases_kidneys" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>}
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Щитовидная железа (диагноз, поставленный врачом)</div>
        {!edit && client.diseases_thyroid && <div className="tabs__value">{client.diseases_thyroid}</div>}
        {!edit && !client.diseases_thyroid && <div className="tabs__value">&mdash;</div>}
        {edit && <div className="tabs__value">
          <InputUserForm type="text" value={form.diseases_thyroid} name="diseases_thyroid" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>}
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Сердечно сосудистая система (диагноз, поставленный врачом)</div>
        {!edit && client.diseases_cardio && <div className="tabs__value">{client.diseases_cardio}</div>}
        {!edit && !client.diseases_cardio && <div className="tabs__value">&mdash;</div>}
        {edit && <div className="tabs__value">
          <InputUserForm type="text" value={form.diseases_cardio} name="diseases_cardio" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>}
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Гинекологические заболевания (диагноз, поставленный врачом)</div>
        {!edit && client.diseases_gynecology && <div className="tabs__value">{client.diseases_gynecology}</div>}
        {!edit && !client.diseases_gynecology && <div className="tabs__value">&mdash;</div>}
        {edit && <div className="tabs__value">
          <InputUserForm type="text" value={form.diseases_gynecology} name="diseases_gynecology" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>}
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Другие заболевания</div>
        {!edit && client.diseases_other && <div className="tabs__value">{client.diseases_other}</div>}
        {!edit && !client.diseases_other && <div className="tabs__value">&mdash;</div>}
        {edit && <div className="tabs__value">
          <InputUserForm type="text" value={form.diseases_other} name="diseases_other" onChange={handleChangeForm}/>
        </div>}
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Аллергии</div>
        <ul className={"tabs__value" + (!edit ? " tabs__value--accent" : "")}>
          {edit && form && <InputDropdown value={form.allergies} options={userAllergies} className="tabs__input" placeholder="Указать аллергию" name="allergies" handleSelected={handleAllergySelected}/>}
          {
            form.allergies && form.allergies.length > 0 && form.allergies.map((i, k) => <li key={k} className="tabs__elem">{i}{edit === true && <span className="tabs__elem--close" onClick={() => handleAllergyDeleted(k)}>{i_close()}</span>}</li>)
          }
          {
            form.allergies && form.allergies.length === 0 && <li className="tabs__elem">Нет аллергий</li>
          }
        </ul>
      </div>
      {edit && form && <div className="tabs__buttons">
        <span className="tabs__btn tabs__btn--canceling btn pointer" onClick={handleCancel}>Отменить</span>
        <span className="tabs__btn tabs__btn--save btn pointer" onClick={handleSave}>Сохранить</span>
      </div>}
    </div>;
  }

  return <div className={"user-info__characters" + (edit ? " user-info__characters--dropdown" : "")}>
    {!edit && <span className="user-info__edit edit help pointer" onClick={() => setEdit(true)}>Ред.</span>}
    {edit && form && <select className="user-info__select select" disabled={edit === 'loading'} style={{marginTop: 0}} value={''} onChange={handleDiseaseSelected}>
      <option value="">Указать заболевание</option>
      {diseaseOptions.map((i, k) => <option key={k} value={i}>{i}</option>)}
    </select>}
    <ul className="user-info__list">
      {
        form.diseases && form.diseases.length > 0 && form.diseases.map((i, k) => <li key={k} className="user-info__item">{i}</li>)
      }
      {
        form.diseases && form.diseases.length === 0 && <li className="user-info__item">Нет болезней</li>
      }
    </ul>
    <div className="user-info__help help">Аллергии</div>
    {edit && form && <InputDropdown value={form.allergies} options={userAllergies} className="user-info__input" placeholder="Указать аллергию" name="allergies" handleSelected={handleAllergySelected}/>}
    <ul className={"user-info__list" + (!edit ? " user-info__list--accent" : "")}>
      {
        form.allergies && form.allergies.length > 0 && form.allergies.map((i, k) => <li key={k} className="user-info__item">{i}</li>)
      }
      {
        form.allergies && form.allergies.length === 0 && <li className="user-info__item">Нет аллергий</li>
      }
    </ul>
    {edit && form && <div className="user-info__buttons">
      <span className="user-info__btn pointer" onClick={handleCancel}>Отменить</span>
      <span className="user-info__btn user-info__btn--accent pointer" onClick={handleSave}>Сохранить</span>
    </div>}
  </div>;
}
